import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { LocalizedText, useHandler } from 'labguard-cdk'
import { groupListQuery } from 'src/components/App/Groups/GroupListView'
import { AddCommentModal } from 'src/components/common'
import { useMutation } from 'react-apollo'

const mutation = gql`
  mutation deleteChannel($id: ID!, $comment: String!) {
    deleteChannel(id: $id, comment: $comment) {
      id
    }
  }
`

function DeleteChannelModal({ channelId, ...props }) {
  const [deleteChannel] = useMutation(mutation, {
    variables: { id: channelId },
    refetchQueries: [{ query: groupListQuery }],
    update: (cache, { data: { deleteChannel } }) => cache.deleteFragment(deleteChannel),
  })

  const onConfirm = useHandler(comment => deleteChannel({ variables: { comment } }))

  return (
    <AddCommentModal
      title={<LocalizedText id="WEB_CHANNEL_DELETE_COMMENT" />}
      inputMessage={<LocalizedText id="WEB_CHANNEL_DELETE_DISCLAIMER" />}
      required
      onConfirm={onConfirm}
      {...props}
    />
  )
}

DeleteChannelModal.propTypes = {
  channelId: PropTypes.string,
}

export default DeleteChannelModal
